import React from "react";
import { useParams, useHistory } from "react-router-dom";
import { Typography, Card, Table, Button } from "antd";
import {
  useGetRegistryProjectDetailsQuery,
  useGetRegistryProjectYieldDetailsQuery,
} from "./store/registryprojectdetailsapi";
import { useGetRegistryPreEntitlementDetailsQuery } from "./store/registrypreentitlementapi";
import { RegistryDisplayOrganizationName } from "./RegistryDisplayOrgName";
import { ColumnsType } from "antd/es/table";

interface RouteParams {
  id: string;
}

interface ProjectData {
  _id: string;
  name: string;
  organization: string;
}

interface YieldData {
  yield_id: string;
  period: string;
  pre_credits: number | null;
}

const RegistryTransactionPageView: React.FC = () => {
  const { id } = useParams<RouteParams>();
  console.log("Id", id);
  const history = useHistory();

  const { data: projectData, isLoading } = useGetRegistryProjectDetailsQuery(
    id,
    {
      skip: !id,
    }
  );
  const { data: yieldData } = useGetRegistryProjectYieldDetailsQuery(
    projectData?.data?.[0]?._id,
    {
      skip: !projectData,
    }
  );

  // Extracting yield IDs from yieldData
  const yieldIdsList: string[] =
    yieldData?.map((yieldDetails: YieldData) => yieldDetails?.yield_id) || [];

  const { data: preEntitlementData, isLoading: isPreEntilementDataLoading } =
    useGetRegistryPreEntitlementDetailsQuery(
      { yield_ids: yieldIdsList },
      { skip: !yieldIdsList.length }
    );

  if (!isPreEntilementDataLoading) {
    console.log("PreEntitlement Data", preEntitlementData);
  }

  const handleGoBack = (): void => {
    history.push({
      pathname: `/${id}`,
    });
  };

  const transactionColumns: ColumnsType<YieldData> = [
    {
      title: "Period",
      dataIndex: "period",
      key: "period",
      render: (record: string) => {
        return (
          <Typography.Text style={{ fontSize: 16 }}>
            {record}
          </Typography.Text>
        );
      },
    },
    {
      title: "Organization",
      key: "organization",
      render: () => {
        return (
          <Typography.Text style={{ fontSize: 16 }}>
            {
              <RegistryDisplayOrganizationName
                orgid={projectData?.data?.[0]?.organization}
                place="table"
              />
            }
          </Typography.Text>
        );
      },
    },
    {
      title: "Credit Type",
      key: "credittype",
      render: (record: YieldData) => {
        return record.pre_credits !== null && record.pre_credits !== undefined
          ? "Dockal Pre-Credit"
          : null;
      },
    },
    {
      title: "Quantity",
      dataIndex: "pre_credits",
      key: "pre_credits",
      render: (record: number | null) => {
        const formattedRecord =
          record != null
            ? (record === 0 ? "-" : null) ||
              (record % 1 !== 0
                ? record.toFixed(4).replace(/\.?0+$/, "")
                : record.toFixed(0))
            : "-";
        return (
          <Typography.Text style={{ fontSize: 16 }}>
            {formattedRecord}
          </Typography.Text>
        );
      },
    },
  ];

  const filteredYieldData = yieldData?.filter(
    (data: YieldData) =>
      data?.pre_credits !== null && data?.pre_credits !== undefined
  );

  return (
    <div>
      {!isLoading && (
        <div style={{ minHeight: "80vh" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 24,
              }}
            >
              <div>
                <Typography.Title level={2} style={{ margin: 0 }}>
                  {projectData?.data?.[0]?.name}
                </Typography.Title>
              </div>
              <div style={{ textAlign: "right" }}>
                <Button
                  type="primary"
                  onClick={handleGoBack}
                  style={{ backgroundColor: "#08979C", color: "white" }}
                >
                  Back
                </Button>
              </div>
            </div>

            <Typography.Title
              level={2}
              style={{ marginTop: "2rem", marginBottom: 12 }}
            >
              Carbon Credits Overview
            </Typography.Title>
            <Typography.Paragraph style={{ fontSize: 16, marginBottom: 24 }}>
              Access a complete overview of all carbon credits in the Dockal Registry. Track credit status,
              issuance history, and retirement records across all certified projects.
            </Typography.Paragraph>
            <div>
              <Card>
                <Table
                  dataSource={filteredYieldData?.filter(
                    (record: YieldData) =>
                      record?.pre_credits !== null &&
                      record?.pre_credits !== 0
                  )}
                  columns={transactionColumns}
                  pagination={{
                    pageSizeOptions: ["10", "50", "100"],
                    showSizeChanger: true,
                  }}
                />
              </Card>
            </div>
          </div>
      )}
    </div>
  );
};

export default RegistryTransactionPageView;
